import Vue from 'vue';
import store from '@/app/app-state';
import { bus } from '@/main';

// @ts-ignore
const appUser = window.appSetup?.user;
const status = appUser?.authenticationStatus;
// @ts-ignore
const AVAILABLE_CAMPAIGN_IDS = [];
const AVAILABLE_SEA_CAMPAIGN_IDS = ['70', '71'];
const AVAILABLE_JOB_CAMPAIGN_IDS = ['72'];

const isUserLoggedIn = () =>
  status === 'authenticated' || status === 'known' || store.getters['user/isLoggedIn'];
const isUserAuthenticated = () =>
  status === 'authenticated' || store.getters['user/isAuthenticated'];

const openModal = (to, from, next, modal = 'login') => {
  store.commit('setRedirectUrlAfterLogin', to.fullPath.replace(/[&?]jl_source=(.*?)(?=&|$)/, ''));

  let redirectUrl = `/?modal=${modal}&redirectBackUrl=${to.path}`;
  if (to.query.jl_source) {
    redirectUrl += `&jl_source=${from.query.jl_source}`;
  }
  window.location.href = redirectUrl;
};

const showLoginFormForNotLoggedUsersWithRedirect = (to, from, next) => {
  if (isUserLoggedIn()) {
    next();
    return;
  }
  openModal(to, from, next);
};

const showLimitedLoginForm = (to, from, next) => {
  if (isUserAuthenticated()) {
    next();
    return;
  }
  if (isUserLoggedIn()) {
    window.location.href =
      '/home?modal=limited-login&redirectBackUrl=' + encodeURIComponent(to.fullPath);
    return;
  }

  openModal(to, from, next, 'login');
};

const validateRegistration = (to, from, next) => {
  let name = '404';
  let query = to.query;

  if (to.name === 'registration' && to.query.campaignId === undefined) {
    name = 'home';
    query = {
      ...to.query,
      modal: 'registration',
    };
  }

  if (!AVAILABLE_CAMPAIGN_IDS.includes(to.query.campaignId)) {
    next({
      ...to,
      name,
      query: {
        ...query,
      },
    });
  }
  next();
};

const validateJobRegistration = (to, from, next) => {
  if (!AVAILABLE_JOB_CAMPAIGN_IDS.includes(to.query.campaignId)) {
    next({
      ...to,
      name: '404',
      query: {
        ...to.query,
      },
    });
  }
  next();
};

const validateSEARegistration = (to, from, next) => {
  if (!AVAILABLE_SEA_CAMPAIGN_IDS.includes(to.params.campaignId)) {
    next({
      ...to,
      name: '404',
      query: {
        ...to.query,
      },
    });
  }
  next();
};

const pagesRoutes = [
  // redirection for legacy my-jobleads url
  {
    name: 'my-jobleads',
    path: '/my-jobleads',
    beforeEnter: showLoginFormForNotLoggedUsersWithRedirect,
    redirect: () => (window.location.href = '/home'),
  },
  // modals redirection
  {
    name: 'login',
    path: '/login',
    redirect: (to) => ({
      name: 'home',
      query: {
        ...to.query,
        modal: 'login',
      },
    }),
  },
  {
    name: 'email-notifications',
    path: '/manage-email-notifications',
    component: () => import(/* webpackChunkName: "registration" */ './unsubscribe/index.vue'),
  },
  {
    name: 'registration',
    path: '/registration',
    component: () => import(/* webpackChunkName: "registration" */ './registration/index.vue'),
    meta: {
      jlSourcePrefix: 'registration',
    },
    beforeEnter: validateRegistration,
  },
  {
    name: 'registration-sea',
    path: '/registration/:campaignId/:type/:language/:locationCountry/:searchTerm/:location/:keywords',
    component: () => import(/* webpackChunkName: "registration-sea" */ './registration/_sea.vue'),
    meta: {
      jlSourcePrefix: 'registration-sea',
    },
    beforeEnter: validateSEARegistration,
  },
  {
    name: 'registration-job',
    path: '/registration/job',
    component: () => import(/* webpackChunkName: "registration-job" */ './registration/job.vue'),
    meta: {
      jlSourcePrefix: 'registration-job',
    },
    beforeEnter: validateJobRegistration,
  },
  {
    name: 'billing-address',
    path: '/billing-address',
    component: () =>
      import(/* webpackChunkName: "account-billing" */ './account/billing-address.vue'),
    meta: {
      jlSourcePrefix: 'billingaddreess',
      hideNavigation: true,
    },
    beforeEnter: showLoginFormForNotLoggedUsersWithRedirect,
  },
  {
    name: 'home',
    path: '/',
    component: () => import(/* webpackChunkName: "home" */ './index/index.vue'),

    beforeEnter: (to, from, next) => {
      if (isUserLoggedIn()) {
        window.location.href = '/home';
        return;
      }

      next();
    },

    meta: {
      jlSourcePrefix: 'home',
    },
  },
  // search
  {
    path: '/search/headhunter',
    name: 'search-headhunter',
    component: () =>
      import(/* webpackChunkName: "search-headhunter" */ './search/headhunter/index.vue'),
    meta: {
      showHeadhunterBookmarksMobileButton: true,
      jlSourcePrefix: 'hhsearch',
    },
  },
  {
    path: '/search/jobs',
    name: 'search-jobs',
    component: () => import(/* webpackChunkName: "search-jobs" */ './search/jobs/index.vue'),
    meta: {
      showJobBookmarksMobileButton: true,
      jlSourcePrefix: 'jobs',
    },
  },
  // {
  //   path: '/:locale/jobs/:slug',
  //   name: 'search-jobs-slug',
  //   component: () => import(/* webpackChunkName: "seo-search-jobs" */ './search/jobs/_seo.vue'),
  //   meta: {
  //     showJobBookmarksMobileButton: true,
  //     jlSourcePrefix: 'jobs',
  //   },
  //   beforeEnter: (to, from, next) => {
  //     // @ts-ignore
  //     const ALLOWED_LOCALES = window.appSetup.seo.locales || [];
  //     if (!ALLOWED_LOCALES.includes(to.params.locale)) {
  //       const { slug } = to.params;
  //       // @ts-ignore
  //       const currentLocale = window.appSetup.seo?.current || 'en-us';
  //       next(`/${currentLocale}/jobs/${slug}`);
  //       return;
  //     }
  //     next();
  //   },
  // },
  // {
  //   path: '/headhunter-jobs/:countryCode/:slug',
  //   name: 'search-headhunter-jobs-slug',
  //   component: () => import(/* webpackChunkName: "seo-search-jobs" */ './search/jobs/_seo.vue'),
  //   meta: {
  //     showJobBookmarksMobileButton: true,
  //     jlSourcePrefix: 'jobs',
  //   },
  //   beforeEnter: (to, from, next) => {
  //     const ALLOWED_COUNTRIES = ['are', 'sgp'];
  //     if (!ALLOWED_COUNTRIES.includes(to.params.countryCode)) {
  //       const { countryCode, slug } = to.params;
  //       // @ts-ignore
  //       const currentLocale = window.appSetup.seo?.current || 'en-us';
  //       next(`/${currentLocale}/jobs/${countryCode}/${slug}`);
  //       return;
  //     }
  //     next();
  //   },
  // },
  {
    path: '/search/jobs/hh/:headhunterId',
    name: 'search-jobs-headhunter',
    props: true,
    component: () => import(/* webpackChunkName: "search-jobs" */ './search/jobs/index.vue'),
    meta: {
      showJobBookmarksMobileButton: true,
      jlSourcePrefix: 'jobs',
    },
  },

  // job
  {
    path: '/job/:id',
    name: 'job-preview',
    component: () => import(/* webpackChunkName: "job-preview" */ './job/_id.vue'),
    meta: {
      showJobBookmarksMobileButton: true,
      jlSourcePrefix: 'jobdetail',
    },
  },
  // job end

  // headhunter
  {
    path: '/headhunter/:id',
    name: 'headhunter-preview',
    component: () => import(/* webpackChunkName: "headhunter-preview" */ './headhunter/_id.vue'),
    meta: {
      showHeadhunterBookmarksMobileButton: true,
      jlSourcePrefix: 'hhpreview',
    },

    beforeEnter: showLoginFormForNotLoggedUsersWithRedirect,
  },
  // {
  //   path: '/headhunter/profiles/:id',
  //   name: 'headhunter-preview-external',
  //   component: () => import(/* webpackChunkName: "headhunter-preview" */ './headhunter/_id.vue'),
  //   meta: {
  //     showHeadhunterBookmarksMobileButton: true,
  //     jlSourcePrefix: 'hhprofile',
  //   },

  //   beforeEnter: (to, from, next) => {
  //     if (isUserPremium()) {
  //       next({
  //         name: 'headhunter-preview',
  //         params: { ...to.params },
  //         query: { ...to.query },
  //       });
  //       return;
  //     }

  //     next();
  //   },
  // },
  // headhunter end

  // user
  {
    path: '/account',
    name: 'account',
    component: () => import(/* webpackChunkName: "account" */ './account/index.vue'),
    meta: {
      jlSourcePrefix: 'account',
    },
    beforeEnter: showLimitedLoginForm,
  },

  // reviews
  {
    path: '/reviews',
    name: 'reviews',
    component: () => import(/* webpackChunkName: "reviews" */ './reviews/index.vue'),
    meta: {
      jlSourcePrefix: 'reviews',
    },
  },
  // resume pages
  {
    path: '/my-free-resume-review',
    name: 'free-review',
    beforeEnter: () => {
      window.location.href = '/free-resume-review/report';
    },
  },
  {
    path: '/resume-writing',
    name: 'resume-writing',
    component: () =>
      // @ts-ignore
      import(/* webpackChunkName: "resume-writing" */ './resume/resume-writing/index.vue'),
    meta: {
      jlSourcePrefix: 'resume_writing',
    },
  },
  {
    path: '/change-password',
    name: 'change-password',
    redirect: (to) => ({
      name: 'home',
      query: {
        ...to.query,
        modal: 'change-password',
      },
    }),
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    redirect: (to) => ({
      name: 'home',
      query: {
        ...to.query,
        modal: 'forgot-password',
      },
    }),
  },

  // terms
  {
    path: '/site-notice',
    name: 'site-notice',
    component: () => import(/* webpackChunkName: "site-notice" */ './site-notice/index.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import(/* webpackChunkName: "privacy-policy" */ './privacy-policy/index.vue'),
  },
  {
    path: '/terms-of-use',
    name: 'terms-of-use',
    component: () => import(/* webpackChunkName: "terms-of-use" */ './terms-of-use/index.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ './contact/index.vue'),
  },
  {
    path: '/my-guides',
    name: 'my-guides',
    component: () => import(/* webpackChunkName: "my-guides" */ './my-guides/index.vue'),
    beforeEnter: showLoginFormForNotLoggedUsersWithRedirect,
    meta: {
      jlSourcePrefix: 'my-guides',
    },
  },
];
export default pagesRoutes;
